import React from 'react';
import { Spinner } from 'react-bootstrap';
import './Loader.scss';

// Loader component.
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <Spinner className="spinner-border" animation="border" role="status" />
    </div>
  );
};

export default Loader;
